export default __webpack_public_path__ + "static/media/hearing-loss-toolbox.74b12d70.svg";